import React, { useState } from "react";
import { useTranslation } from "react-i18next";

const MCQAssignment = ({ assignment, score, setScore }) => {
  const { t } = useTranslation();
  const [selectedAnswers, setSelectedAnswers] = useState({});
  const [submitted, setSubmitted] = useState(false);
  

  if (!assignment || !assignment.assignmentText?.length)
    return <p className="text-gray-500 text-lg">{t("assignment.noAssignment")}</p>;

  const handleSelect = (questionId, optionKey) => {
    if (submitted) return; // prevent changing after submission
    setSelectedAnswers(prev => ({ ...prev, [questionId]: optionKey }));
  };

  const handleSubmit = () => {
    let correctCount = 0;
    assignment.assignmentText.forEach(q => {
      const ansObj = assignment.answers.find(a => a.questionId === q.id);
      if (ansObj?.correctAnswer === selectedAnswers[q.id]) correctCount++;
    });
    setScore(correctCount);
    setSubmitted(true);
  };

  const cleanText = (text) => text.replace(/^\*\*\s*/, ""); // remove leading **

  return (
    <div className="space-y-6">
      {assignment.assignmentText.map((q) => {
        const ansObj = assignment.answers.find(a => a.questionId === q.id);
        const selected = selectedAnswers[q.id];

        return (
          <div
            key={q.id}
            className="bg-gray-100 p-4 rounded-md border border-gray-200"
          >
            {/* Question Number & Text */}
            <p className="font-semibold text-gray-800 mb-2">
              {q.questionNumber}. {cleanText(q.questionText)}
            </p>

            {/* Options */}
            <div className="space-y-1 ml-4">
              {q.options &&
                Object.entries(q.options).map(([key, value]) => {
                  const isCorrect = ansObj?.correctAnswer === key;
                  const isSelected = selected === key;
                  const bgColor =
                    submitted && isCorrect
                      ? "bg-green-200"
                      : submitted && isSelected && !isCorrect
                      ? "bg-red-200"
                      : "bg-gray-50";

                  return (
                    <label
                      key={key}
                      className={`flex items-center gap-2 p-2 rounded cursor-pointer ${bgColor}`}
                    >
                      <input
                        type="radio"
                        name={q.id}
                        value={key}
                        checked={isSelected || false}
                        onChange={() => handleSelect(q.id, key)}
                        disabled={submitted}
                        className="form-radio"
                      />
                      <span className="font-semibold">{key})</span>
                      <span>{value}</span>
                    </label>
                  );
                })}
            </div>

            {/* Explanation */}
            {submitted && ansObj && (
              <div className="mt-2 p-2 bg-blue-50 border-l-4 border-blue-400 rounded">
                <p>
                  <strong>{t("assignment.correctAnswer")}</strong> {ansObj.correctAnswer}
                </p>
                <p className="text-gray-700">{ansObj.explanation}</p>
              </div>
            )}
          </div>
        );
      })}

      {/* Submit Button */}
      {!submitted && (
        <button
          onClick={handleSubmit}
          className="px-5 py-2 mt-4 bg-blue-600 hover:bg-blue-700 text-white rounded-lg"
        >
          {t("assignment.submit")}
        </button>
      )}

      {/* Result */}
      {submitted && (
        <div className="mt-4 p-4 bg-green-100 border-l-4 border-green-400 rounded text-lg font-semibold">
          {t("assignment.youScored")} {score} {t("assignment.outOf")} {assignment.assignmentText.length}
        </div>
      )}
    </div>
  );
};

export default MCQAssignment;
